module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-SemiBold-878e0cfc04d6108e9f97f3ce94e25b5e.woff2";